// Core Module
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";

// Config
import { environment } from "../environments/environment";
import { AppConfig } from "./app.config";

// Authentication and services
import { OAuthModule, OAuthStorage } from "angular-oauth2-oidc";
import { UploadInterceptor } from "./services/upload.interceptor";
import { AuthInterceptor } from "./user/auth.interceptor";

// ApplicationModules
import { AppRoutingModule } from "./app-routing.module";
import { UserModule } from "./user/user.module";

// Store
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { AppEffects } from "./app.effects";
import { metaReducers, reducers } from "./reducers";

// Main Component
import { AppComponent } from "./app.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { ShellComponent } from "./components/shell/shell.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { TopMenuComponent } from "./components/top-menu/top-menu.component";

import { AccountListComponent } from "./components/account-list/account-list.component";
import { CookiePolicyComponent } from "./components/cookie-policy/cookie-policy.component";

// Component Module
import { GoogleMapsModule } from "@angular/google-maps";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { GaugesModule } from "@progress/kendo-angular-gauges";
import { LayoutModule } from "@progress/kendo-angular-layout";

// Pages
import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { HomeComponent } from "./pages/home/home.component";

export function initializeApp(appConfig: AppConfig) {
  return (): Promise<any> => {
    return appConfig.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    TopMenuComponent,
    FooterComponent,
    HomeComponent,
    AccountListComponent,
    ShellComponent,
    CookiePolicyComponent,
    PagenotfoundComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    GoogleMapsModule,
    BrowserAnimationsModule,
    BrowserModule,
    DropDownsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    UserModule,
    AppRoutingModule,
    GaugesModule,
    LayoutModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([AppEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: OAuthStorage, useValue: localStorage },
    DeviceDetectorService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
